import { Injectable, inject } from '@angular/core';

import { APP_CONFIG } from '../config/app-config';

type LogLevel = 'debug' | 'error' | 'info' | 'silent' | 'warn';

const LOG_LEVEL_WEIGHT: Readonly<Record<LogLevel, number>> = {
  debug: 10,
  info: 20,
  warn: 30,
  error: 40,
  silent: 100,
};

@Injectable({ providedIn: 'root' })
export class LoggerService {
  private readonly threshold = LOG_LEVEL_WEIGHT[inject(APP_CONFIG).logLevel];

  debug(message: string, ...context: readonly unknown[]): void {
    this.write('debug', message, context);
  }

  info(message: string, ...context: readonly unknown[]): void {
    this.write('info', message, context);
  }

  warn(message: string, ...context: readonly unknown[]): void {
    this.write('warn', message, context);
  }

  error(message: string, ...context: readonly unknown[]): void {
    this.write('error', message, context);
  }

  private write(
    level: Exclude<LogLevel, 'silent'>,
    message: string,
    context: readonly unknown[],
  ): void {
    if (LOG_LEVEL_WEIGHT[level] < this.threshold) {
      return;
    }

    // The logger is the sole console sink; application code uses this service.
    // eslint-disable-next-line no-console
    console[level](`[celeri] ${message}`, ...context);
  }
}
